module.exports = "<div class=\"for-save-as-image catalog-view container-fluid\"><sc-catalog-view-node ng-repeat=\"filter in $ctrl.filter.children\" model=\"$ctrl.model\" filter=\"filter\"></sc-catalog-view-node></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/catalog/catalog-view.component.html
// module id = 978
// module chunks = 0